import { connect } from 'react-redux';
import { SurveyStep } from '../../models';
import { IApplicationState } from '../../store';
import { NavigationActions } from '../../store/NavigationActions';
import { ActionCreators as SurveyBuilderActionCreators } from '../../store/SurveyBuilderStore';
import { ActionCreators as SurveyActionCreators } from '../../store/SurveyStore';
import { SurveyPageStateSetterBase } from './SurveyPageStateSetterBase';

const mapStateToProps = (state: IApplicationState, ownProps: { currentStep: SurveyStep }) => ({
	...state.audienceDetails,
	...state.distributionList,
	...state.emailTemplates,
	...state.survey,
	...state.surveyBuilder,
	...state.surveyImage,
	...state.surveyTheme,
	...ownProps,
});

export const SurveyPageStateSetter: React.ComponentType<any> = connect(mapStateToProps, {
	Get: SurveyActionCreators.GetSurvey,
	SetDefaultState: SurveyActionCreators.SetDefaultState,
	...SurveyBuilderActionCreators,
	...NavigationActions,
})(SurveyPageStateSetterBase);
